module.exports = __webpack_public_path__ + "static/bird-4db13d9a8415dee593216045d91eb2fe.jpg";